import styled from 'styled-components';

export const Box = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;
